<template>
  <b-modal
    v-model="open"
    size="lg"
    centered
    no-close-on-esc
    no-close-on-backdrop>

    <div slot="modal-title">
      <h4 class="m-0">
        <span v-if="loading">Downloading. Please wait!</span>
        <span v-else>Select columns to include</span>
      </h4>
    </div>

    <div v-if="loading" class="text-center my-5">
      <i class="fa fa-3x fa-spin fa-spinner" />
    </div>
    <template v-else>
      <b-form-checkbox :checked="allChecked" @change="onToggleAll" class="mb-3">
        <strong>Toggle All</strong>
      </b-form-checkbox>

      <b-form-checkbox
        v-for="col in allColumns"
        v-model="project"
        name="columns"
        :key="col.slug"
        :value="col.slug">
        {{ titleCase(col.name) }}
      </b-form-checkbox>

      <div slot="modal-footer">
        <b-button @click="onClose" slot="modal-cancel">Cancel</b-button>
        <b-button
          @click="onDownload"
          slot="modal-ok"
          variant="primary"
          :disabled="!project.length">
          Download
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import {E_DOWNLOAD, eventHub, fullURL} from '../utils';
  import {titleCase} from './Insights/utils';
  import axios from 'axios';

  export default {
    name: 'Downloader',

    created() {
      eventHub.$on(E_DOWNLOAD, this.download);
    },

    data() {
      return {
        open: false,
        project: [],
        filter: null,
        params: null,
        loading: false,
        titleCase
      };
    },

    methods: {
      download({filter, params}) {
        this.filter = filter;
        this.params = params || {};

        const project = params ? params['search_on'] : null;
        if (project && project.length > 0) {
          this.project = project;
        } else {
          this.project = this.allColumns.map(x => x.slug);
        }

        this.loading = false;
        this.open = true;
      },

      onClose() {
        this.open = false;
      },

      onDownload() {
        this.loading = true;
        const params  = {...this.params, project: this.project};
        axios.post(fullURL('segment/download'), {...this.filter, params})
          .then(({data}) => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'customers.csv');
            document.body.appendChild(link);
            link.click();
            this.onClose();
          })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
      },

      onToggleAll() {
        this.project = this.allChecked ? [] : this.allColumns.map(x => x.slug);
      }
    },

    computed: {
      allColumns() {
        const file = this.$store.getters.getActiveFile('customers');
        const columns = file ? file.columns : [];
        return columns.filter(col => col['keep']);
      },

      allChecked() {
        return this.project && this.allColumns && this.allColumns.length === this.project.length;
      }
    }
  };
</script>

<style scoped>

</style>
